import React, { useEffect, useState } from "react";
import { Layout, Spin } from "antd";
import { withRouter } from "react-router-dom";
import DashboardHeader from "../../components/header/index";
import DashboardSider from "../../components/sidebar/index";
import Router from "./Router";
import BreadCrumbs from "./BreadCrumbs";
import { useDispatch } from "react-redux";
import { setScope } from "../../features/user/UserSlice";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { usePermission } from "../../hooks/accessControl";
import { useProfile } from "../../hooks/index";
import {
  SolutionOutlined,
  HeartOutlined,
  RocketOutlined,
  MedicineBoxOutlined,
  BarChartOutlined,
  DollarCircleOutlined,
  MoneyCollectOutlined,
  DiffOutlined,
  FilePdfOutlined,
  ContactsOutlined,
  CrownOutlined,
  TeamOutlined,
  SettingOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";

const BranchDashboard = withRouter((props) => {
  const { location } = props;
  const dispatch = useDispatch();
  let { branchId } = useParams();
  const scopePrefix = useSelector((state) => state.user.scopePrefix);
  const signingOutProcess = useSelector((state) => state.user.igningOutProcess);
  const organizationDetails = useSelector(
    (state) => state.organization.details
  );
  const [allowedFeatures, setAllowedFeatures] = useState([]);

  useEffect(() => {
    const scope = `branches/${branchId}/`;
    dispatch(setScope(scope));
    if (organizationDetails && organizationDetails.features) {
      const features =
        organizationDetails.features &&
        organizationDetails.features.map((i) => i.name);
      setAllowedFeatures(features);
    }
  }, [branchId, dispatch, organizationDetails]);
  const profile = useProfile();

  const crmResources = [
    // {
    //   resource: "leads",
    //   icon: <TeamOutlined />,
    // },
    // {
    //   resource: "contacts",
    //   icon: <ContactsOutlined />,
    // },
    {
      resource: "crm_patients",
      icon: <CrownOutlined />,
    },
    // {
    //   resource: "campaigns",
    //   icon: <RocketOutlined />,
    // },
    // {
    //   resource: "events_schedule",
    //   icon: <BarChartOutlined />,
    // },
  ];

  const ok2goResources = [
    {
      resource: "ok2go_btl",
      icon: <ClockCircleOutlined />,
    },
    // {
    //   resource: "ok2go_revaha",
    //   icon: <ClockCircleOutlined />,
    // },
  ];

  const routes = [
    { resource: "patients", icon: <MedicineBoxOutlined /> },
    { resource: "employees", icon: <SolutionOutlined /> },
    { resource: "gaps", icon: <DiffOutlined /> },
    {
      resource: "gaps",
      resourceName: "diaries_approval",
      icon: <DiffOutlined />,
    },
    { resource: "tasks", icon: <MedicineBoxOutlined /> },
    { resource: "branch_salary", icon: <DollarCircleOutlined /> },
    { resource: "accounting", icon: <MoneyCollectOutlined /> },
    {
      resource: "crm",
      icon: <BarChartOutlined />,
      childrenResources: crmResources,
      subMenu: true,
      feature: true,
    },
    { resource: "day_center", icon: <MoneyCollectOutlined />, feature: true },
    {
      resource: "order_import",
      icon: <MoneyCollectOutlined />,
      feature: true,
    },
    { resource: "reports", icon: <BarChartOutlined /> },
    { resource: "clients", icon: <RocketOutlined /> },
    { resource: "assets", icon: <FilePdfOutlined />, feature: true },
    {
      resource: "ok2go",
      icon: <ClockCircleOutlined />,
      childrenResources: profile?.admin
        ? ok2goResources
        : ok2goResources.filter(
            (j) =>
              profile?.roles?.[0]?.permissions?.some((i) =>
                i.includes(j.resource)
              ) ?? false
          ),
      subMenu: true,
      // feature: true,
    },
    { resource: "profile", icon: <HeartOutlined /> },
  ];
  const routeDefinitions = profile.admin
    ? routes.filter(
        (r) => !r.feature || (r.feature && allowedFeatures.includes(r.resource))
      )
    : routes.filter(
        (r) =>
          usePermission(branchId, r.resource, "viewer") &&
          (!r.feature || (r.feature && allowedFeatures.includes(r.resource)))
      );

  return (
    <Layout style={{ height: "100vh" }}>
      <DashboardHeader />
      <Layout>
        <DashboardSider routeDefinitions={routeDefinitions} />
        <Layout style={{ height: "100%", display: "flex" }}>
          <BreadCrumbs location={location} />
          {routeDefinitions[0] && scopePrefix && !signingOutProcess && (
            <Router defaultResource={routeDefinitions[0].resource} />
          )}
          {signingOutProcess && <Spin size="large" />}
        </Layout>
      </Layout>
    </Layout>
  );
});

export default BranchDashboard;
